"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.segmentPage = void 0;
const logging_1 = require("@nerdwallet/logging");
const utils_1 = __importStar(require("./lib/utils"));
const segmentLogger = (0, logging_1.getLogger)('SegmentPage');
/** Wrapper function for sending Segment analytics.page events. */
const segmentPage = (name, standardPageViewProps, additionalEventProps) => {
    try {
        utils_1.default.page(name, Object.assign(Object.assign(Object.assign(Object.assign({}, (0, utils_1.convertCamelCaseToSnakeCase)(standardPageViewProps)), (0, utils_1.getDeviceInfo)()), (0, utils_1.getDeployableInfo)()), additionalEventProps));
    }
    catch (e) {
        /*
          A race condition occurs where segment.page() is called before the segment analytics lib has loaded
          from global-markup, triggering an error log. Although once the lib is loaded, page() is called again,
          so functionality is not affected. Therefore, avoid logging an error for that edge case.
         */
        if (typeof utils_1.default !== 'undefined') {
            segmentLogger.error(e);
        }
    }
};
exports.segmentPage = segmentPage;
